import type { AxiosInstance, AxiosError } from 'axios';

export interface AtlassianUser {
  account_id: string;
  email?: string;
  name?: string;
  picture?: string;
  nickname?: string;
}

const UNAUTHENTICATED_STATUS_CODES = [401, 402];

export const getAtlassianUser = async (
  api: AxiosInstance,
): Promise<AtlassianUser | null> => {
  try {
    const response = await api.get<AtlassianUser>('/gateway/api/me');
    return response.data;
  } catch (error) {
    const status = (error as AxiosError)?.response?.status;
    // Silently ignore 401/402 — user is simply not authenticated
    if (status !== undefined && UNAUTHENTICATED_STATUS_CODES.includes(status)) {
      return null;
    }
    // Re-throw all other errors so callers can handle/log them
    throw error;
  }
};
